export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5224.d055b668.jpg";